var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApidocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1589_13525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2499 68.2499V21.9374L46.3125 -0.000114799L19.4999 0.000321269L19.5 4.87489H46.3125V14.6249C46.3125 16.5643 47.0829 18.4242 48.4542 19.7956C49.8256 21.1669 51.6855 21.9374 53.6249 21.9374H63.3749V68.2499C63.3749 69.5428 62.8613 70.7828 61.9471 71.697C61.0328 72.6112 59.7929 73.1249 58.4999 73.1249V77.9999C61.0858 77.9999 63.5657 76.9726 65.3942 75.1441C67.2227 73.3157 68.2499 70.8357 68.2499 68.2499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7263 25.2489L14.1406 12.2757H14.4326L17.802 25.2489H10.7263ZM21.104 38H28L18.2737 6H10.7263L1 38H7.37935L9.4459 30.1719H19.0824L21.104 38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 45V78H7.38518V67.5258H12.5561C19.5484 67.5258 24 63.158 24 56.2973C24 49.368 19.6833 45 12.8712 45H1ZM7.38518 50.3286H11.2523C15.4342 50.3286 17.5249 52.2954 17.5249 56.2516C17.5249 60.2309 15.4342 62.1746 11.2523 62.1746H7.38518V50.3286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 78V72.4202H45.2197V50.5798H52V45H32V50.5798H38.7798V72.4202H32V78H52Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1589_13525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApidocument);
export default __webpack_public_path__ + "static/media/api document.f15a1b222390ede1926c3b55258d8bf2.svg";
export { ForwardRef as ReactComponent };